import { ITextValue } from '@/types/common';
import { PipelineStageEnum } from '@/bundles/Pipelines/types/stageEnum';
import { BusinessLineEnum, BusinessLineLabels, SourceEnum } from '@/bundles/Pipelines/types';
import { SourceLabels } from '@/bundles/Pipelines/consts';
import { PipelineTransactionCategoryEnum } from '@/bundles/Pipeline/types';

export const getDefaultPipelineFormData = () => ({
  property_type: '',
  category: '',
  deal_name: '',
  size: 0,
  land_size: 0,
  size_max: null,
  land_size_max: null,
  source: null,
  consideration: '',
  commission: '',
  commission_per: '',
  commission_total: '',
  probability: '',
  close_date: null,
  stage: PipelineStageEnum.appointment_pending,
  brokers: [],
  agreement: {
    type: '',
    files: [],
    expiration_date: '',
  },
  is_close_date_estimated: true,
  businessLine: BusinessLineEnum.brokerage
});

export const getBusinessLines = (): ITextValue<BusinessLineEnum>[] =>
  Object.values(BusinessLineEnum).map(value => ({
    text: BusinessLineLabels[value],
    value,
  }));

export const getSources = (): ITextValue<SourceEnum>[] =>
  Object.values(SourceEnum).map(value => ({
    text: SourceLabels[value],
    value,
  }));

export const getSelectItems = () => ({
  transactionCategories: Object.values(PipelineTransactionCategoryEnum),
  probability: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  sources: getSources(),
  businessLines: getBusinessLines()
});
